/**
* Created by ferto
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 01/02/2018.
*
* main-search Component
*/
<template>
  <div class="main-search">
    <i class="icon-search"/>
    <input
      type="text"
      v-model="searchInput"
      placeholder="Buscar"
      @input="onSearch"
      width="100%"
    >
  </div>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
export default {
  name: 'MainSearch',
  data () {
    return {
      timeOut: null,
      searchTimeOut: 1000,
      searchInput: null
    }
  },
  methods: {
    search () {
      let query = Object.assign({}, this.$route.query)
      query.search = this.searchInput
      this.$router.replace({query: query})
    },
    onSearch (e) {
      clearTimeout(this.timeOut)
      this.timeOut = setTimeout(this.search, this.searchTimeOut)
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
  .main-search {
    padding: 9px 20px;
    float: left;
  }

  i {
    font-size: 20px;
    color: #999999;
    pointer-events: none;
    position: absolute;
    top: 14px;
  }

  input {
    border: none;
    font-size: 20px;
    padding-left: 30px;
    padding-top: 5px;
    @include font-primary(14px, light);
    color: #555555;
    width: 40%;
    &:focus {
      outline: none;
    }
    &::placeholder {
      @include font-primary(14px, light);
      color: #aaaaaa;
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/main-layout/main-search.vue